export const DEFAULT_USER_COUNT_VALIDATION_VALUE = 0;
